import { buildUri } from "../../utils/dom";

export class ResourcesService {

    #resources = [];

    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/c/resources`);
    }

    async loadResources({ sitename, culture, applicationId }) {

        if (this.#resources?.length > 0) {
            return;
        }

        const params = new URLSearchParams();

        if (!sitename) {
           throw new Error("sitename is not defined");
        }

        if (!applicationId) {
            throw new Error("applicationId is not defined");
        }

        if (!culture) {
            throw new Error("culture is not defined");
        }

        params.append("v24a", applicationId);
        params.append("v24c", culture);
        params.append("v24si", sitename);

        const uri = `${this.uri}?${params.toString()}`;

        try {
            this.#resources = await fetch(uri)
                .then(response => response.json())
                .then(data => data.resources);
        } catch (e) {
            throw new Error(e);
        }
    }

    getResource(resourceTitle, defaultValue = "#missing resource#") {
        const res = this.#resources.find(m => m.title === resourceTitle);
        return res ? res.value : defaultValue;
    }

    formatResourceKey(name, prefix, suffix = '') {
        return `${prefix}_${name.toUpperCase().replace(/[^\w]+/g, '')}${suffix ? '_' + suffix : ''}`;
    }
    
    getFormattedResource(name, prefix, suffix = '', defaultValue) {
        const resourceKey = this.formatResourceKey(name, prefix, suffix);
        return this.getResource(resourceKey, defaultValue);
    }
}